export var tableBackgroundOnMobile = "background";
export var cellBackground = "backgroundLight";
export var borderEmphasis = "low";
export var biggerScreenBreakpoint = "large";
export var defaultCellPaddingSpace = 1;
export var activeColor = "primary";
export var borderRadiusOnBiggerScreen = "large";
export var borderWidthOnBiggerScreen = 1;